<template>
  <input ref="inputRef" type="text" />
</template>

<script>
  import { useCurrencyInput } from 'vue-currency-input'

  export default {
    name: 'CurrencyInput',
    props: {
      modelValue: Number,
      options: {
        type: Object,
        default: () => ({ currency: 'JPY', symbol: false, locale: 'ja', currencyDisplay: 'hidden', valueRange: { min: 0 } }),
      },
    },
    setup(props) {
      const { inputRef } = useCurrencyInput(props.options)

      return { inputRef }
    },
  }
</script>
